// src/pages/Booknow.jsx
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Breadcrumb from "../Components/Breadcrumb";
import Steptwo from "../Components/Steptwo";
import Stepone from "../Components/Stepone";
import Pagehelmet from "./Pagehelmet";
import Loader from "../Components/Loader";
import './Booknow.scss';

function Booknow() {
    const API_BASE = process.env.REACT_APP_API_BASE;

  const [step, setStep] = useState(1);
  const [openAccordion, setOpenAccordion] = useState("group");
  const [selectedPass, setSelectedPass] = useState(null);
const passes = [
  {
    id: 1,
    title: "Super Early Bird",
    subtitle: "Closes on 4 Jan 2026",
    price: 199,
    oldPrice: 299,
    type: "superearly"
  },
  {
    id: 2,
    title: "Early Bird",
    subtitle: "Opens 5 Jan · Closes 8 Feb 2026",
    price: 299,
    oldPrice: 399,
    type: "earlybird"
  },
  {
    id: 3,
    title: "Regular Pass",
    subtitle: "Opens 9 Feb · Closes 19 Apr 2026",
    price: 399,
    oldPrice: 499,
    highlight: true,
    type: "regular"
  }
];



  const [qtyByPass, setQtyByPass] = useState(
    passes.reduce((acc, p) => ({ ...acc, [p.id]: 1 }), {})
  );

  const [delegateData, setDelegateData] = useState({});
  const [termsAccepted, setTermsAccepted] = useState(false);

  const inc = (id) => setQtyByPass((q) => ({ ...q, [id]: (q[id] || 1) + 1 }));
  const dec = (id) =>
    setQtyByPass((q) => ({ ...q, [id]: Math.max(1, (q[id] || 1) - 1) }));

  const toggleAccordion = (key) => {
    setOpenAccordion(openAccordion === key ? null : key);
  };

  const handleBook = (pass) => {
    setSelectedPass(pass);
    setStep(2);

    const count = qtyByPass[pass.id];
    const initialDelegates = {};
    for (let i = 0; i < count; i++) {
      initialDelegates[i] = { passType: pass.title };
    }
    setDelegateData(initialDelegates);
  };

  const delegates = selectedPass ? qtyByPass[selectedPass.id] : 0;
  const subtotal = selectedPass ? selectedPass.price * delegates : 0;
  const tax = subtotal * 0.18;
  const total = subtotal + tax;

  const [bookingId, setBookingId] = useState(null);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const paypalRef = useRef(null);

const handleSubmitBooking = async (delegatesArray) => {
  try {
    setProcessing(true);

    // If delegatesArray not provided, fallback to delegateData
    const delegates = delegatesArray || Object.values(delegateData).map((d) => ({
      firstName: d.firstName?.trim() || "",
      lastName: d.lastName?.trim() || "",
      company: d.company?.trim() || "",
      email: d.email?.trim() || "",
      mobile: d.mobile?.trim() || "",
      passType: d.passType || selectedPass?.title || "",
    }));

    if (!selectedPass) return false;

    const payload = {
      type: "pass",
      delegates,
      subtotal: subtotal || 0,
      tax: tax || 0,
      paymentMethod: null,
    };

    const res = await axios.post(
     `${API_BASE}/bookings`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    const bookingReturnedId = res.data.bookingId || res.data.booking?._id;
    if (bookingReturnedId) setBookingId(bookingReturnedId);

    setShowPaymentOptions(true);
    return true;
  } catch (err) {
    console.error(err);
    return false;
  } finally {
    setProcessing(false);
  }
};





  useEffect(() => {
    if (
      showPaymentOptions &&
      paypalRef.current &&
      !window.paypal &&
      process.env.REACT_APP_PAYPAL_CLIENT_ID
    ) {
      const id = "paypal-sdk";
      if (!document.getElementById(id)) {
        const script = document.createElement("script");
        script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=USD`;
        script.id = id;
        script.async = true;
        document.body.appendChild(script);
      }
    }
  }, [showPaymentOptions]);

  const handleStartPayPal = async () => {
    setPaymentError(null);
    if (!bookingId) {
      setPaymentError("Missing booking reference. Please try saving booking again.");
      return;
    }
    if (!window.paypal) {
      setPaymentError("PayPal SDK not loaded. Please refresh and try again.");
      return;
    }
    if (paypalRef.current) paypalRef.current.innerHTML = "";

    window.paypal
      .Buttons({
        style: { layout: "vertical", color: "gold", shape: "rect", label: "paypal" },
        createOrder: async () => {
          try {
            const createRes = await axios.post(
               `${API_BASE}/payment/paypal/create-order`,
              { bookingId }
            );
            return createRes.data.id;
          } catch (err) {
            console.error("PayPal create order error:", err.response?.data || err.message);
            setPaymentError("Failed to create PayPal order. Try again.");
            throw err;
          }
        },
        onApprove: async (data) => {
          setProcessing(true);
          try {
            const captureRes = await axios.post(
              `${API_BASE}/payment/paypal/capture-order`,
              { orderId: data.orderID, bookingId }
            );
            if (captureRes.data && captureRes.data.success) {
              alert("✅ Payment successful and booking confirmed! Invoice/email will be sent.");
              resetFormAfterSuccess();
            } else {
              alert("Payment verification issue. Contact admin.");
            }
          } catch (err) {
            console.error("PayPal capture error:", err.response?.data || err.message);
            alert("Payment capture failed. Please contact support.");
          } finally {
            setProcessing(false);
          }
        },
        onError: (err) => {
          console.error("PayPal error:", err);
          setPaymentError("PayPal encountered an error. Try again.");
        },
        onCancel: (data) => {
          console.log("PayPal payment cancelled", data);
        },
      })
      .render(paypalRef.current);
  };

  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) return resolve();
      const s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error(`Failed to load ${src}`));
      document.body.appendChild(s);
    });

  const handleStartRazorpay = async () => {
    setPaymentError(null);
    if (!bookingId) {
      setPaymentError("Missing booking reference. Please try saving booking again.");
      return;
    }
    try {
      setProcessing(true);
      const createRes = await axios.post(
         `${API_BASE}/payment/razorpay/create-order`   ,
        { bookingId }
      );
      const data = createRes.data || {};
      const order_id = data.id || data.orderId || (data.order && data.order.id);
      const order_amount = data.amount || (data.order && data.order.amount);
      const currency = data.currency || (data.order && data.order.currency) || "INR";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order_amount,
        currency,
        name: "ARO Events",
        description: `Booking ${bookingId}`,
        order_id: order_id,
        handler: async function (response) {
          try {
            setProcessing(true);
            const verifyRes = await axios.post(
            `${API_BASE}/payment/razorpay/verify-payment` ,
              {
                razorpay_order_id: order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                bookingId,
                amount: order_amount,
              }
            );
            if (verifyRes.data && verifyRes.data.success) {
              alert("✅ Razorpay payment successful! Booking confirmed.");
              resetFormAfterSuccess();
            } else {
              alert("Payment verification failed; contact support.");
            }
          } catch (err) {
            console.error("Razorpay verification error:", err.response?.data || err.message || err);
            alert("Payment verification failed. Please contact admin.");
          } finally {
            setProcessing(false);
          }
        },
        prefill: {
          name: delegateData[0]?.firstName
            ? `${delegateData[0].firstName} ${delegateData[0].lastName || ""}`
            : "",
          email: delegateData[0]?.email || "",
          contact: delegateData[0]?.mobile || "",
        },
        notes: { bookingId },
        theme: { color: "#3399cc" },
      };
      await loadScript("https://checkout.razorpay.com/v1/checkout.js");
      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function () {
        setPaymentError("Payment failed or was cancelled. Try again.");
      });
      rzp.open();
    } catch (err) {
      console.error("Razorpay error:", err.response?.data || err.message || err);
      setPaymentError("Failed to start Razorpay. Try again.");
    } finally {
      setProcessing(false);
    }
  };

  const resetFormAfterSuccess = () => {
    setStep(1);
    setOpenAccordion("group");
    setSelectedPass(null);
    setQtyByPass(passes.reduce((acc, p) => ({ ...acc, [p.id]: 1 }), {}));
    setDelegateData({});
    setTermsAccepted(false);
    setBookingId(null);
    setShowPaymentOptions(false);
    setProcessing(false);
    setPaymentError(null);
  };

  // ---------- Render ----------
  return (
    <div className="registration-page">
        {processing && <Loader />}
      <Pagehelmet pageTitle="Book Ticket Now" />
      <Breadcrumb title="Book Tickets Now" />

      <section className="booknow-section py-5">
        <div className="container">
          {/* Step Progress */}
       <div style={{ width: "100%", display: "flex", justifyContent: "center", margin: "40px 0" }}>
  <ul style={{ 
      listStyle: "none", 
      display: "flex", 
      padding: 0, 
      margin: 0, 
      gap: "120px", 
      position: "relative", 
      width: "100%", 
      maxWidth: "600px", 
      justifyContent: "space-between" 
    }}>
    
    {/* Step 1 */}
    <li style={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          fontSize: "15px", 
          fontWeight: 600, 
          color: step === 1 ? "#d32f2f" : "#888", 
          position: "relative", 
          flex: 1 
        }}>
      <div style={{ 
            width: "40px", 
            height: "40px", 
            borderRadius: "50%", 
            border: `3px solid ${step >= 1 ? "#d32f2f" : "#ccc"}`, 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            fontWeight: 700, 
            background: step >= 1 ? "#d32f2f" : "#fff", 
            color: step >= 1 ? "#fff" : "#000", 
            boxShadow: step >= 1 ? "0 0 10px rgba(211,47,47,0.5)" : "none",
            transition: "all 0.3s ease"
          }}>
        1
      </div>
      <span style={{ marginTop: "10px" }}>Select your pass</span>

      {/* Connector line */}
      <div style={{
        position: "absolute",
        top: "20px",
        right: "-60px",
        height: "3px",
        width: "120px",
        background: step >= 2 ? "#d32f2f" : "#ccc",
        zIndex: -1,
        transition: "all 0.3s ease"
      }}></div>
    </li>

    {/* Step 2 */}
    <li style={{ 
          display: "flex", 
          flexDirection: "column", 
          alignItems: "center", 
          fontSize: "15px", 
          fontWeight: 600, 
          color: step === 2 ? "#d32f2f" : "#888", 
          position: "relative", 
          flex: 1 
        }}>
      <div style={{ 
            width: "40px", 
            height: "40px", 
            borderRadius: "50%", 
            border: `3px solid ${step >= 2 ? "#d32f2f" : "#ccc"}`, 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center", 
            fontWeight: 700, 
            background: step >= 2 ? "#d32f2f" : "#fff", 
            color: step >= 2 ? "#fff" : "#000", 
            boxShadow: step >= 2 ? "0 0 10px rgba(211,47,47,0.5)" : "none",
            transition: "all 0.3s ease"
          }}>
        2
      </div>
      <span style={{ marginTop: "10px" }}>Submit Details</span>
    </li>
  </ul>
</div>


          <div className="row g-4">
            {/* Left Content */}
            <div className="col-lg-8">
              {step === 1 && (
                <Stepone
                  passes={passes}
                  qtyByPass={qtyByPass}
                  inc={inc}
                  dec={dec}
                  handleBook={handleBook}
                  openAccordion={openAccordion}
                  toggleAccordion={toggleAccordion}
                />
              )}

              {step === 2 && selectedPass && (
                <Steptwo
                  delegates={delegates}
                  selectedPass={selectedPass}
                  qtyByPass={qtyByPass}
                  setQtyByPass={setQtyByPass}
                  delegateData={delegateData}
                  setDelegateData={setDelegateData}
                  termsAccepted={termsAccepted}
                  setTermsAccepted={setTermsAccepted}
                  showPaymentOptions={showPaymentOptions}
                  bookingId={bookingId}
                  paymentError={paymentError}
                  processing={processing}
                  handleSubmitBooking={handleSubmitBooking}
                  handleStartPayPal={handleStartPayPal}
                  handleStartRazorpay={handleStartRazorpay}
                  paypalRef={paypalRef}
                />
              )}
            </div>

            {/* Right Sidebar */}
            <div className="col-lg-4">
              <div className="sidebar-card shadow-sm rounded p-4">
                {step === 1 && (
                  <>
                    <h6 className="fw-bold mb-3">Pass Includes Following</h6>
                    <ul className="list-unstyled small">
                      {[
                        "Watch any talk live during the conference days",
                        "Certificate of participation",
                        "Q&A discussions",
                        "Access to two-day event including all stages",
                        "Access to post-conference materials",
                        "Networking opportunities on the Exhibition Floor",
                        "Access to all networking activities",
                        "End of Day 1 networking drinks reception",
                      ].map((item, i) => (
                        <li key={i} className="mb-2 d-flex">
                          <i className="fa fa-check-circle text-pink me-2"></i>
                          {item}
                        </li>
                      ))}
                    </ul>
                    <p className="small mt-3">
                      Unsure on which pass to select? Contact us at{" "}
                      <a href="mailto:info@aroevents.com">info@aroevents.com</a>
                    </p>
                  </>
                )}

                {step === 2 && selectedPass && (
                  <>
                    <h6 className="fw-bold mb-3">Your Order</h6>
                    <div className="order-box p-3 rounded mb-3">
                      <h6 className="fw-semibold mb-1">{selectedPass.title}</h6>
                      <p className="small text-muted mb-1">
                        Number of delegate(s) ({delegates} × US${selectedPass.price})
                      </p>
                      <div className="d-flex justify-content-between">
                        <span className="small">Subtotal</span>
                        <span className="small">US${subtotal.toFixed(2)}</span>
                      </div>
                    </div>
                    <div className="d-flex justify-content-between small mb-1">
                      <span>Service Tax (18%)</span>
                      <span>US${tax.toFixed(2)}</span>
                    </div>
                    <div className="d-flex justify-content-between fw-bold">
                      <span>Total</span>
                      <span className="text-primary">US${total.toFixed(2)}</span>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Booknow;
